

const AboutDocuments = () => {
    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center">
            <div className="my-[20px] h-11 text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text text-base leading-normal text-[24px] lg:text-[32px] xl:leading-[44.8px] font-extrabold font-['Open Sans']">
                Правоустанавливающие документы<br />
            </div>
            <div className="mt-[20px] text-center text-[#544a28] text-[10px] lg:text-xl font-normal font-['Open Sans']">
                Программное обеспечение «Ключ-Астром» – российское APM (Application <br />
                Performance Monitoring) решение, зарегистрированное в реестре отечественного <br/>
                ПО (свидетельство о государственной регистрации No 2017614533 от 18.04.2017).<br />
                Владелец прав и исходного кода ПО «Ключ-АСТРОМ» – ООО «Рускомтехнологии».<br /><br />
                
                ООО «Рускомтехнологии» отечественный разработчик программного обеспечения,<br />
                внесенный в реестр аккредитованных организаций, осуществляющих деятельность в<br />
                области информационных технологий.
            </div>
        </div>
    );
}

export default AboutDocuments;